import { render, staticRenderFns } from "./swiperSmall3.vue?vue&type=template&id=2e93dc4e&scoped=true&"
import script from "./swiperSmall3.vue?vue&type=script&lang=js&"
export * from "./swiperSmall3.vue?vue&type=script&lang=js&"
import style0 from "./swiperSmall3.vue?vue&type=style&index=0&id=2e93dc4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93dc4e",
  null
  
)

export default component.exports